import { combineReducers } from '@reduxjs/toolkit';
import { appSlice } from './modules/app/appSlice';
import { tmpSlice } from './modules/tmp/tmpSlice';

const reducer = combineReducers({
	app: appSlice.reducer,
	tmp: tmpSlice.reducer,
});

export default reducer;
